<template>
  <v-navigation-drawer v-model="isOpen" temporary>
    <div class="sidebar-filters">
      <header class="sidebar-filters__header">
        <h2 class="sidebar-filters__title">Filter Results</h2>
        <button class="sidebar-filters__close-button" @click.stop="petStore.closeSideNav()" small>
          <v-icon dark> mdi-close </v-icon>
        </button>
      </header>


      <!-- {{dogBreeds}} -->
      <div class="sidebar-filters__filterbox sidebar-filters__filterbox">
        <div class="sidebar-filters__filterbox-header">
          <p>
            Type: <span class="is-capitalized">{{ speciesCategory }}</span>
          </p>
        </div>
        <div class="
            sidebar-filters__filterbox-filters
            sidebar-filters__filterbox-filters--split
          ">
          <button class="
              sidebar-filters__btn sidebar-filters__btn--square
              icon-btn icon-btn--dog
            " :class="{ 'is-active': speciesCategory == 'dogs' }" @click.stop="speciesCategory = 'dogs'"></button>
          <button class="
              sidebar-filters__btn sidebar-filters__btn--square
              icon-btn icon-btn--cat
            " :class="{ 'is-active': speciesCategory == 'cats' }" @click.stop="speciesCategory = 'cats'"></button>
          <button class="
              sidebar-filters__btn sidebar-filters__btn--square
              icon-btn icon-btn--gizmo
            " :class="{ 'is-active': speciesCategory == 'others' }" @click.stop="speciesCategory = 'others'"></button>
        </div>
      </div>

      <div v-if="speciesCategory == 'others'" class="sidebar-filters__filterbox">
        <div class="sidebar-filters__filterbox-header">
          <p>Species:</p>
        </div>
        <div class="sidebar-filters__filterbox-filters">
          <vue-select v-model="speciesSelect" :options="species" multiple></vue-select>

        </div>
      </div>

      <div v-if="speciesCategory !== 'others'" class="sidebar-filters__filterbox">
        <div class="sidebar-filters__filterbox-header">
          <p>Breeds</p>
        </div>
        <div class="sidebar-filters__filterbox-filters dogs" v-if="speciesCategory == 'dogs'">
          <vue-select v-model="dogBreedSelect" :options="dogBreeds" label="title" multiple></vue-select>
        </div>
        <div class="sidebar-filters__filterbox-filters cats" v-if="speciesCategory == 'cats'">
          <vue-select v-model="catBreedSelect" :options="catBreeds" label="title" multiple></vue-select>
        </div>
      </div>

      <div class="sidebar-filters__filterbox">
        <div class="sidebar-filters__filterbox-header">
          <p>Sex</p>
        </div>
        <div class="
            sidebar-filters__filterbox-filters
            sidebar-filters__filterbox-filters--centered
          ">
          <button class="sidebar-filters__btn" :class="{ 'is-active': sexSelect == 'Male' }"
            @click.stop="sexSelect = 'Male'">
            Male
          </button>
          <button class="sidebar-filters__btn" :class="{ 'is-active': sexSelect == 'Female' }"
            @click.stop="sexSelect = 'Female'">
            Female
          </button>
        </div>
      </div>

      <div class="sidebar-filters__filterbox">
        <div class="sidebar-filters__filterbox-header">
          <p>Age</p>
        </div>
        <div class="sidebar-filters__filterbox-filters">
          <vue-select v-model="ageSelect" :options="ageSelectOptions" label="label"></vue-select>
        </div>
      </div>
      <div class="sidebar-filters__action-buttons">
        <v-btn class="sidebar-filters__btn-clear" @click.stop="clearFilters()">
          Clear Filters
        </v-btn>
        <v-btn class="sidebar-filters__btn-apply bg-lightgreen" @click.stop="applyFilters()">
          Apply
        </v-btn>
      </div>
    </div>
  </v-navigation-drawer>
</template>
<script>
import { usePetStore } from "../stores/PetStore";

export default {
  data() {
    return {
      speciesCategory: "dogs",
      sexSelect: null,
      speciesSelect: null,
      dogBreedSelect: null,
      catBreedSelect: null,
      ageSelect: null,
      ageSelectOptions: [
        { label: "Any", value: null },
        { label: "Baby", value: "Baby" },
        { label: "Young", value: "Young" },
        { label: "Adult", value: "Adult" },
        { label: "Senior", value: "Senior" },
      ],
      speciesSelectOptions: [
        { label: "25 Miles", value: 25 },
        { label: "50 Miles", value: 50 },
        { label: "100 Miles", value: 100 },
        { label: "250 Miles", value: 250 },
        { label: "500 Miles", value: 500 },
      ],
    };
  },
  methods: {
    selectSpecies(species) {
      this.speciesCategory = species;
    },
    clearFilters() {
      this.speciesCategory = "dogs";
      this.sexSelect = null;
      this.dogBreedSelect = null;
      this.catBreedSelect = null;
      this.speciesSelect = null;
      this.ageSelect = null;
    },
    setInitialFilters() {
      const initialFilters = this.petStore.initialFilters;
      if(!initialFilters) {
        return false;
      }
      // console.log(this.petStore.initialFilters)
      this.speciesCategory = initialFilters.speciesCategory;
      this.sexSelect = initialFilters.sex;
      this.dogBreedSelect = this.speciesCategory == "dogs" ? initialFilters.breeds : null;
      this.catBreedSelect = this.speciesCategory == "cats" ? initialFilters.breeds : null;
      this.speciesSelect = initialFilters.species;
      this.ageSelect = initialFilters.ageGroup;
   
      
    },
    applyFilters() {
      const filters = {
        speciesCategory: this.speciesCategory,
        sex: this.sexSelect,
        ageGroup: this.ageSelect,
        species:
          this.speciesCategory == "dogs" || this.speciesCategory == "cats"
            ? [this.speciesCategory]
            : this.speciesSelect,
        breeds: this.selectedBreeds,
      };
      console.log(filters)
      this.petStore.updatePetFilters(filters);
    },
  },
  computed: {
    isOpen: function () {
      return this.petStore.isSideNavOpen;
    },
    dogBreeds: function () {
    return this.petStore.dogBreeds;
    },
    catBreeds: function () {
    return this.petStore.catBreeds;
    },
    species: function () {
    return this.petStore.species;
    },

    selectedBreeds: function () {
      let selectedBreeds = null;
      switch (this.speciesCategory) {
        case "dogs":
          selectedBreeds = this.dogBreedSelect;
          break;
        case "cats":
          selectedBreeds = this.catBreedSelect;
          break;

        default:
          selectedBreeds = null;
          break;
      }
      return selectedBreeds;
    },
  },
  created() {

    

  },
  mounted() {
    // console.log("sidenav mounted");
    this.setInitialFilters();

  },
  setup() {
    const petStore = usePetStore();
    return { petStore };
  },

};
</script>

<style lang="scss" >
/* Global */
@import "scss/global/variables.scss";
@import "scss/global/mixins.scss";
@import "scss/global/breakpoints.scss";
@import "scss/global/layout.scss";
@import "scss/global/colors.scss";
@import "scss/global/fonts.scss";
@import "scss/global/typography.scss";
@import "scss/global/icon-buttons.scss";

.sidebar-filters {
  padding: 10px 25px;

  &__header {
    padding: 10px 0;
    text-align: center;
    position: relative;
  }

  &__close-button {
    position: absolute;
    top: 0;
    right: -10px;
    width: 30px;
    height: 30px;
    background-color: $lightblue;
    border-radius: 50%;
    border: 1px solid rgba(151, 140, 131, 0.18);
    box-shadow: 0 0 9.5px 0 rgb(2 3 3 / 10%);

    i {
      @include acent();
      font-size: 18px;
    }
  }

  &__title {
    font-size: rem(20);
    font-weight: bold;
    margin-bottom: 0.5em;
  }

  &__action-buttons {
    @include flex-sides;
    margin-bottom: 1rem;

    button {
      border: 1px solid rgba(151, 140, 131, 0.18);
      box-shadow: 0 0 9.5px 0 rgb(2 3 3 / 10%);
    }
  }

  &__filterbox {
    margin-bottom: 1rem;
  }

  &__filterbox-header {
    margin-bottom: 0.5rem;
  }

  &__filterbox-filters {
    &--split {
      @include flex-sides;
    }

    &--centered {
      @include flex-center;

      button {
        margin: 0 0.5rem;
      }
    }
  }

  &__btn {
    display: block;
    height: 50px;
    flex: 1 0 auto;
    background-color: $lightblue;
    border-radius: 3px;
    border: 1px solid $lightgreyborder;
    box-shadow: 0 0 9.5px 0 rgba(2, 3, 3, 0.1);
    transition: 0.15s all ease-in-out;

    &--square {
      width: 65px;
      height: 65px;
      flex: 0 0 auto;
    }

    &.is-active {
      border: 2px solid $successgreen;
    }
  }

  /* Vuetify Overrides  */
  .v-btn {
    text-transform: none !important;
  }

  /*
  .v-input {
   display: block;
  }
  .v-field {
    // grid-template-areas: initial;
    padding-right: 0;
  }
  .v-select {
    width: 100% !important;
  }
  .v-input__control {
    grid-area: initial;
  }
  .v-field__input {
    @include flex-center;
    padding: 5px 12px;
    background-color: $lightblue;
    border-radius: 3px;
  }
  .v-autocomplete--single.v-text-field input {
    @include acent;
  }

  .v-field__prepend-inner,
  .v-field__append-inner,
  .v-field__clearable,
  .v-input__details,
  .v-field__overlay {
    display: none !important;
  }
*/
}
</style>